"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/transaction.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Ftransaction.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.controlCategoryToJSON = exports.controlCategoryFromJSON = exports.transactionTypeToJSON = exports.transactionTypeFromJSON = exports.TransactionCategoryIcon = exports.TransactionCategory = exports.TransactionTagsEntry = exports.Transaction = exports.ControlCategory = exports.TransactionType = void 0;
const amount_1 = require("../common/amount");
const payment_context_1 = require("./payment-context");
const transaction_error_code_1 = require("./transaction-error-code");
const transaction_limit_error_1 = require("./transaction-limit-error");
const transaction_status_1 = require("./transaction-status");
const protobufPackage = 'com.step.common.proto';
var TransactionType;
(function (TransactionType) {
    TransactionType["INVALID_TRANSACTION_TYPE"] = "INVALID_TRANSACTION_TYPE";
    /**
     * ATM_FEE - ATM transactions.
     */
    TransactionType["ATM_FEE"] = "ATM_FEE";
    TransactionType["ATM_FEE_REVERSAL"] = "ATM_FEE_REVERSAL";
    TransactionType["ATM_FEE_REIMBURSEMENT"] = "ATM_FEE_REIMBURSEMENT";
    TransactionType["ATM_FEE_REIMBURSEMENT_REVERSAL"] = "ATM_FEE_REIMBURSEMENT_REVERSAL";
    /**
     * CARD_AUTH - Card transactions.
     */
    TransactionType["CARD_AUTH"] = "CARD_AUTH";
    TransactionType["CARD_RE_AUTH"] = "CARD_RE_AUTH";
    TransactionType["CARD_REVERSAL"] = "CARD_REVERSAL";
    TransactionType["CARD_CAPTURE"] = "CARD_CAPTURE";
    TransactionType["CARD_REFUND"] = "CARD_REFUND";
    TransactionType["CARD_SETTLEMENT"] = "CARD_SETTLEMENT";
    TransactionType["CARD_DISPUTE"] = "CARD_DISPUTE";
    TransactionType["CARD_DISPUTE_REVERSAL"] = "CARD_DISPUTE_REVERSAL";
    TransactionType["CARD_DISPUTE_INITIATION"] = "CARD_DISPUTE_INITIATION";
    TransactionType["CARD_DISPUTE_RESOLUTION"] = "CARD_DISPUTE_RESOLUTION";
    TransactionType["CARD_DEBIT"] = "CARD_DEBIT";
    TransactionType["CARD_CREDIT"] = "CARD_CREDIT";
    TransactionType["CARD_PURCHASE_TRANSFER"] = "CARD_PURCHASE_TRANSFER";
    TransactionType["CARD_PURCHASE_ROLLOVER"] = "CARD_PURCHASE_ROLLOVER";
    TransactionType["CARD_PURCHASE_TRANSFER_ADJUSTMENT"] = "CARD_PURCHASE_TRANSFER_ADJUSTMENT";
    /**
     * CREDIT_BILLING_PRINCIPAL - Credit bill invoicing and payment transactions.
     */
    TransactionType["CREDIT_BILLING_PRINCIPAL"] = "CREDIT_BILLING_PRINCIPAL";
    TransactionType["CREDIT_BILLING_INTEREST"] = "CREDIT_BILLING_INTEREST";
    TransactionType["CREDIT_BILLING_FEE"] = "CREDIT_BILLING_FEE";
    TransactionType["CREDIT_PAYMENT"] = "CREDIT_PAYMENT";
    TransactionType["CREDIT_BALANCE_CATEGORIZATION"] = "CREDIT_BALANCE_CATEGORIZATION";
    TransactionType["CREDIT_REBALANCE"] = "CREDIT_REBALANCE";
    /**
     * TRANSFER - Transfers.
     */
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["TRANSFER_REVERSAL"] = "TRANSFER_REVERSAL";
    TransactionType["TRANSFER_HOLD"] = "TRANSFER_HOLD";
    TransactionType["TRANSFER_HOLD_REVERSAL"] = "TRANSFER_HOLD_REVERSAL";
    TransactionType["USER_TO_STEP_TRANSFER"] = "USER_TO_STEP_TRANSFER";
    /**
     * METADATA_UPDATE - Metadata transactions.
     */
    TransactionType["METADATA_UPDATE"] = "METADATA_UPDATE";
    TransactionType["PENDING_TRANSFER_DESTINATION"] = "PENDING_TRANSFER_DESTINATION";
    /**
     * FUNDING - Debit card funding transactions.
     */
    TransactionType["FUNDING"] = "FUNDING";
    TransactionType["FUNDING_DISPUTE"] = "FUNDING_DISPUTE";
    TransactionType["FUNDING_DISPUTE_REVERSAL"] = "FUNDING_DISPUTE_REVERSAL";
    TransactionType["FUNDING_REVERSAL"] = "FUNDING_REVERSAL";
    TransactionType["UNAUTHENTICATED_CARD_FUNDING"] = "UNAUTHENTICATED_CARD_FUNDING";
    /**
     * FUNDING_FEE - Funding fees.
     */
    TransactionType["FUNDING_FEE"] = "FUNDING_FEE";
    TransactionType["FUNDING_FEE_REVERSAL"] = "FUNDING_FEE_REVERSAL";
    /**
     * ACH_IN_DEBIT - Bank-originated ACH transactions.
     */
    TransactionType["ACH_IN_DEBIT"] = "ACH_IN_DEBIT";
    TransactionType["ACH_IN_CREDIT"] = "ACH_IN_CREDIT";
    TransactionType["ACH_IN_DEBIT_RETURN"] = "ACH_IN_DEBIT_RETURN";
    TransactionType["ACH_IN_CREDIT_RETURN"] = "ACH_IN_CREDIT_RETURN";
    /**
     * ACH_OUT_DEBIT - Step-originated ACH transactions.
     */
    TransactionType["ACH_OUT_DEBIT"] = "ACH_OUT_DEBIT";
    TransactionType["ACH_OUT_CREDIT"] = "ACH_OUT_CREDIT";
    TransactionType["ACH_OUT_DEBIT_RETURN"] = "ACH_OUT_DEBIT_RETURN";
    TransactionType["ACH_OUT_CREDIT_RETURN"] = "ACH_OUT_CREDIT_RETURN";
    /**
     * CASH_DEPOSIT - Cash deposit transactions.
     */
    TransactionType["CASH_DEPOSIT"] = "CASH_DEPOSIT";
    TransactionType["CASH_DEPOSIT_REVERSAL"] = "CASH_DEPOSIT_REVERSAL";
    TransactionType["CASH_DEPOSIT_SETTLEMENT"] = "CASH_DEPOSIT_SETTLEMENT";
    TransactionType["CASH_DEPOSIT_REV_SHARE_PAYMENT"] = "CASH_DEPOSIT_REV_SHARE_PAYMENT";
    /**
     * LOAN_FUNDING - Pay Over Time loan transactions.
     */
    TransactionType["LOAN_FUNDING"] = "LOAN_FUNDING";
    TransactionType["LOAN_PRINCIPAL"] = "LOAN_PRINCIPAL";
    TransactionType["LOAN_FEE"] = "LOAN_FEE";
    TransactionType["LOAN_PRINCIPAL_PAYMENT"] = "LOAN_PRINCIPAL_PAYMENT";
    TransactionType["LOAN_FEE_PAYMENT"] = "LOAN_FEE_PAYMENT";
    /**
     * CASH_ADVANCE_FUNDING - Cash Advance transactions.
     */
    TransactionType["CASH_ADVANCE_FUNDING"] = "CASH_ADVANCE_FUNDING";
    TransactionType["CASH_ADVANCE_PRINCIPAL"] = "CASH_ADVANCE_PRINCIPAL";
    /**
     * OPTIONAL_FEE_PAYMENT - Discretionary fee transactions.
     */
    TransactionType["OPTIONAL_FEE_PAYMENT"] = "OPTIONAL_FEE_PAYMENT";
    /**
     * REWARD_PAYOUT - Reward transactions.
     */
    TransactionType["REWARD_PAYOUT"] = "REWARD_PAYOUT";
    TransactionType["REWARD_ADJUSTMENT"] = "REWARD_ADJUSTMENT";
    /**
     * CRYPTO_BUY - Crypto transactions.
     */
    TransactionType["CRYPTO_BUY"] = "CRYPTO_BUY";
    TransactionType["CRYPTO_SELL"] = "CRYPTO_SELL";
    TransactionType["CRYPTO_SELL_REVERSAL"] = "CRYPTO_SELL_REVERSAL";
    TransactionType["CRYPTO_TRANSFER"] = "CRYPTO_TRANSFER";
    TransactionType["CRYPTO_TRANSFER_REVERSAL"] = "CRYPTO_TRANSFER_REVERSAL";
    /**
     * CRYPTO_BUY_TRANSFER - Backing transactions for crypto trades.
     */
    TransactionType["CRYPTO_BUY_TRANSFER"] = "CRYPTO_BUY_TRANSFER";
    TransactionType["CRYPTO_BUY_TRANSFER_HOLD"] = "CRYPTO_BUY_TRANSFER_HOLD";
    TransactionType["CRYPTO_BUY_TRANSFER_HOLD_REVERSAL"] = "CRYPTO_BUY_TRANSFER_HOLD_REVERSAL";
    TransactionType["CRYPTO_SELL_TRANSFER"] = "CRYPTO_SELL_TRANSFER";
    /**
     * CHECK_DEPOSIT - Check Deposit transactions.
     */
    TransactionType["CHECK_DEPOSIT"] = "CHECK_DEPOSIT";
    TransactionType["CHECK_DEPOSIT_RETURN"] = "CHECK_DEPOSIT_RETURN";
    TransactionType["CHECK_DEPOSIT_SETTLEMENT"] = "CHECK_DEPOSIT_SETTLEMENT";
    /**
     * CARD_PAYOUT - (Debit) Card Payout transactions.
     */
    TransactionType["CARD_PAYOUT"] = "CARD_PAYOUT";
    TransactionType["CARD_PAYOUT_FEE"] = "CARD_PAYOUT_FEE";
    TransactionType["CARD_PAYOUT_FEE_REVERSAL"] = "CARD_PAYOUT_FEE_REVERSAL";
    TransactionType["CARD_PAYOUT_REVERSAL"] = "CARD_PAYOUT_REVERSAL";
    /**
     * GIFT_CARD_ORDER - Gift card order transactions.
     */
    TransactionType["GIFT_CARD_ORDER"] = "GIFT_CARD_ORDER";
    TransactionType["GIFT_CARD_ORDER_REVERSAL"] = "GIFT_CARD_ORDER_REVERSAL";
    TransactionType["GIFT_CARD_SETTLEMENT"] = "GIFT_CARD_SETTLEMENT";
    /**
     * STOCK_BUY_TRANSFER - Backing transactions for stock trades, corporate actions and backoffice adjustments.
     */
    TransactionType["STOCK_BUY_TRANSFER"] = "STOCK_BUY_TRANSFER";
    TransactionType["STOCK_BUY_TRANSFER_HOLD"] = "STOCK_BUY_TRANSFER_HOLD";
    TransactionType["STOCK_BUY_TRANSFER_HOLD_REVERSAL"] = "STOCK_BUY_TRANSFER_HOLD_REVERSAL";
    TransactionType["STOCK_SELL_TRANSFER"] = "STOCK_SELL_TRANSFER";
    TransactionType["STOCK_CORPORATE_ACTION_DEBIT"] = "STOCK_CORPORATE_ACTION_DEBIT";
    TransactionType["STOCK_CORPORATE_ACTION_CREDIT"] = "STOCK_CORPORATE_ACTION_CREDIT";
    TransactionType["STOCK_BUY_TRANSFER_ADJUSTMENT"] = "STOCK_BUY_TRANSFER_ADJUSTMENT";
    TransactionType["STOCK_SELL_TRANSFER_ADJUSTMENT"] = "STOCK_SELL_TRANSFER_ADJUSTMENT";
    TransactionType["STOCK_INTEREST_ADJUSTMENT_CREDIT"] = "STOCK_INTEREST_ADJUSTMENT_CREDIT";
    TransactionType["STOCK_INTEREST_ADJUSTMENT_DEBIT"] = "STOCK_INTEREST_ADJUSTMENT_DEBIT";
    TransactionType["STOCK_CUSTOMER_ACCOUNT_TRANSFER"] = "STOCK_CUSTOMER_ACCOUNT_TRANSFER";
    /**
     * SAVINGS_INTEREST - Savings specific transactions.
     */
    TransactionType["SAVINGS_INTEREST"] = "SAVINGS_INTEREST";
    /**
     * PHYSICAL_CARD_PAYMENT - Physical goods transactions.
     */
    TransactionType["PHYSICAL_CARD_PAYMENT"] = "PHYSICAL_CARD_PAYMENT";
    TransactionType["PHYSICAL_CARD_TAX"] = "PHYSICAL_CARD_TAX";
    /**
     * POINTS_REWARD - Points specific transactions
     */
    TransactionType["POINTS_REWARD"] = "POINTS_REWARD";
    TransactionType["POINTS_REDEEM"] = "POINTS_REDEEM";
    TransactionType["POINTS_REWARD_ADJUSTMENT"] = "POINTS_REWARD_ADJUSTMENT";
    /**
     * SUBSCRIPTION_FEE - Subscriptions
     */
    TransactionType["SUBSCRIPTION_FEE"] = "SUBSCRIPTION_FEE";
    TransactionType["SUBSCRIPTION_FEE_REFUND"] = "SUBSCRIPTION_FEE_REFUND";
    /**
     * SAVINGS_MATCH - Savings Contribution Matching
     */
    TransactionType["SAVINGS_MATCH"] = "SAVINGS_MATCH";
    TransactionType["DEPRECATED_CREDIT_PAYMENT_INTEREST"] = "DEPRECATED_CREDIT_PAYMENT_INTEREST";
    TransactionType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
/**
 * Transaction categorization for spending / funding controls.
 */
var ControlCategory;
(function (ControlCategory) {
    ControlCategory["INVALID_CONTROL_CATEGORY"] = "INVALID_CONTROL_CATEGORY";
    ControlCategory["INTERNAL_TRANSACTION"] = "INTERNAL_TRANSACTION";
    ControlCategory["CARD_PHYSICAL"] = "CARD_PHYSICAL";
    /**
     * CARD_WALLET - Formerly CARD_ONLINE
     */
    ControlCategory["CARD_WALLET"] = "CARD_WALLET";
    ControlCategory["CARD_VIRTUAL"] = "CARD_VIRTUAL";
    ControlCategory["CARD_GENERIC"] = "CARD_GENERIC";
    ControlCategory["CARD_ATM"] = "CARD_ATM";
    ControlCategory["CARD_CASH_BACK"] = "CARD_CASH_BACK";
    ControlCategory["CARD_OTC_WITHDRAWAL"] = "CARD_OTC_WITHDRAWAL";
    ControlCategory["P2P_TRANSACTION"] = "P2P_TRANSACTION";
    ControlCategory["CARD_FUNDING_TRANSACTION"] = "CARD_FUNDING_TRANSACTION";
    ControlCategory["UNAUTHENTICATED_CARD_FUNDING_TRANSACTION"] = "UNAUTHENTICATED_CARD_FUNDING_TRANSACTION";
    /**
     * ACH_IN_FUNDING - Formerly ACH_IN_TRANSACTION
     */
    ControlCategory["ACH_IN_FUNDING"] = "ACH_IN_FUNDING";
    /**
     * ACH_IN_WITHDRAWAL - Formerly ACH_IN_RETURN
     */
    ControlCategory["ACH_IN_WITHDRAWAL"] = "ACH_IN_WITHDRAWAL";
    /**
     * ACH_OUT_FUNDING - Formerly ACH_OUT_TRANSACTION
     */
    ControlCategory["ACH_OUT_FUNDING"] = "ACH_OUT_FUNDING";
    /**
     * ACH_OUT_WITHDRAWAL - Formerly ACH_OUT_RETURN
     */
    ControlCategory["ACH_OUT_WITHDRAWAL"] = "ACH_OUT_WITHDRAWAL";
    ControlCategory["CASH_DEPOSIT_TRANSACTION"] = "CASH_DEPOSIT_TRANSACTION";
    ControlCategory["CRYPTO_BUY_TRANSFER_TRANSACTION"] = "CRYPTO_BUY_TRANSFER_TRANSACTION";
    ControlCategory["CHECK_DEPOSIT_TRANSACTION"] = "CHECK_DEPOSIT_TRANSACTION";
    ControlCategory["CARD_PAYOUT_TRANSACTION"] = "CARD_PAYOUT_TRANSACTION";
    ControlCategory["USER_TO_STEP_TRANSACTION"] = "USER_TO_STEP_TRANSACTION";
    ControlCategory["STOCK_BUY_TRANSFER_TRANSACTION"] = "STOCK_BUY_TRANSFER_TRANSACTION";
    ControlCategory["POINTS_TRANSACTION"] = "POINTS_TRANSACTION";
    ControlCategory["INTRA_FAMILY_TRANSACTION"] = "INTRA_FAMILY_TRANSACTION";
    ControlCategory["GIFT_CARD_ORDER_TRANSACTION"] = "GIFT_CARD_ORDER_TRANSACTION";
    ControlCategory["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ControlCategory || (exports.ControlCategory = ControlCategory = {}));
function createBaseTransaction() {
    return {
        id: '',
        paymentId: '',
        referenceId: '',
        batchId: '',
        type: TransactionType.INVALID_TRANSACTION_TYPE,
        accountId: '',
        primaryAccountId: '',
        counterPartyAccountId: '',
        amount: amount_1.Amount.fromPartial({}),
        timeMs: '0',
        description: '',
        context: undefined,
        category: undefined,
        tags: {},
        controlCategory: ControlCategory.INVALID_CONTROL_CATEGORY,
        status: transaction_status_1.TransactionStatus.PENDING,
        errorCode: transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE,
        limit: undefined,
        paymentContext: undefined,
        createdAtMs: '0',
        updatedAtMs: '0',
    };
}
exports.Transaction = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            type: isSet(object.type)
                ? transactionTypeFromJSON(object.type)
                : TransactionType.INVALID_TRANSACTION_TYPE,
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            counterPartyAccountId: isSet(object.counterPartyAccountId)
                ? globalThis.String(object.counterPartyAccountId)
                : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            tags: isObject(object.tags)
                ? Object.entries(object.tags).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
            status: isSet(object.status)
                ? (0, transaction_status_1.transactionStatusFromJSON)(object.status)
                : transaction_status_1.TransactionStatus.PENDING,
        };
        if (isSet(object.referenceId)) {
            message.referenceId = globalThis.String(object.referenceId);
        }
        if (isSet(object.batchId)) {
            message.batchId = globalThis.String(object.batchId);
        }
        if (isSet(object.primaryAccountId)) {
            message.primaryAccountId = globalThis.String(object.primaryAccountId);
        }
        if (isSet(object.timeMs)) {
            message.timeMs = globalThis.String(object.timeMs);
        }
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        if (isSet(object.context)) {
            message.context = payment_context_1.PaymentContext.fromJSON(object.context);
        }
        if (isSet(object.category)) {
            message.category = exports.TransactionCategory.fromJSON(object.category);
        }
        if (isSet(object.controlCategory)) {
            message.controlCategory = controlCategoryFromJSON(object.controlCategory);
        }
        if (isSet(object.errorCode)) {
            message.errorCode = (0, transaction_error_code_1.transactionErrorCodeFromJSON)(object.errorCode);
        }
        if (isSet(object.limit)) {
            message.limit = transaction_limit_error_1.TransactionLimitError.fromJSON(object.limit);
        }
        if (isSet(object.paymentContext)) {
            message.paymentContext = payment_context_1.PaymentContext.fromJSON(object.paymentContext);
        }
        if (isSet(object.createdAtMs)) {
            message.createdAtMs = globalThis.String(object.createdAtMs);
        }
        if (isSet(object.updatedAtMs)) {
            message.updatedAtMs = globalThis.String(object.updatedAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.referenceId !== undefined && message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.batchId !== undefined && message.batchId !== '') {
            obj.batchId = message.batchId;
        }
        if (message.type !== TransactionType.INVALID_TRANSACTION_TYPE) {
            obj.type = transactionTypeToJSON(message.type);
        }
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.primaryAccountId !== undefined && message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.counterPartyAccountId !== '') {
            obj.counterPartyAccountId = message.counterPartyAccountId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.timeMs !== undefined && message.timeMs !== '0') {
            obj.timeMs = message.timeMs;
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.context !== undefined) {
            obj.context = payment_context_1.PaymentContext.toJSON(message.context);
        }
        if (message.category !== undefined) {
            obj.category = exports.TransactionCategory.toJSON(message.category);
        }
        if (message.tags) {
            const entries = Object.entries(message.tags);
            if (entries.length > 0) {
                obj.tags = {};
                entries.forEach(([k, v]) => {
                    obj.tags[k] = v;
                });
            }
        }
        if (message.controlCategory !== undefined &&
            message.controlCategory !== ControlCategory.INVALID_CONTROL_CATEGORY) {
            obj.controlCategory = controlCategoryToJSON(message.controlCategory);
        }
        if (message.status !== transaction_status_1.TransactionStatus.PENDING) {
            obj.status = (0, transaction_status_1.transactionStatusToJSON)(message.status);
        }
        if (message.errorCode !== undefined &&
            message.errorCode !== transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE) {
            obj.errorCode = (0, transaction_error_code_1.transactionErrorCodeToJSON)(message.errorCode);
        }
        if (message.limit !== undefined) {
            obj.limit = transaction_limit_error_1.TransactionLimitError.toJSON(message.limit);
        }
        if (message.paymentContext !== undefined) {
            obj.paymentContext = payment_context_1.PaymentContext.toJSON(message.paymentContext);
        }
        if (message.createdAtMs !== undefined && message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== undefined && message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.Transaction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransaction();
        message.id = object.id ?? '';
        message.paymentId = object.paymentId ?? '';
        message.referenceId = object.referenceId ?? '';
        message.batchId = object.batchId ?? '';
        message.type = object.type ?? TransactionType.INVALID_TRANSACTION_TYPE;
        message.accountId = object.accountId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.counterPartyAccountId = object.counterPartyAccountId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.timeMs = object.timeMs ?? '0';
        message.description = object.description ?? '';
        message.context = (object.context !== undefined && object.context !== null)
            ? payment_context_1.PaymentContext.fromPartial(object.context)
            : undefined;
        message.category = (object.category !== undefined && object.category !== null)
            ? exports.TransactionCategory.fromPartial(object.category)
            : undefined;
        message.tags = Object.entries(object.tags ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        message.controlCategory = object.controlCategory ?? ControlCategory.INVALID_CONTROL_CATEGORY;
        message.status = object.status ?? transaction_status_1.TransactionStatus.PENDING;
        message.errorCode = object.errorCode ?? transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE;
        message.limit = (object.limit !== undefined && object.limit !== null)
            ? transaction_limit_error_1.TransactionLimitError.fromPartial(object.limit)
            : undefined;
        message.paymentContext = (object.paymentContext !== undefined && object.paymentContext !== null)
            ? payment_context_1.PaymentContext.fromPartial(object.paymentContext)
            : undefined;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        return message;
    },
};
function createBaseTransactionTagsEntry() {
    return { key: '', value: '' };
}
exports.TransactionTagsEntry = {
    fromJSON(object) {
        const message = {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value) ? globalThis.String(object.value) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== '') {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.TransactionTagsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransactionTagsEntry();
        message.key = object.key ?? '';
        message.value = object.value ?? '';
        return message;
    },
};
function createBaseTransactionCategory() {
    return {
        group: '',
        category: '',
        subCategory: '',
        color: '',
        icon: exports.TransactionCategoryIcon.fromPartial({}),
        hideLocation: false,
    };
}
exports.TransactionCategory = {
    fromJSON(object) {
        const message = {
            group: isSet(object.group) ? globalThis.String(object.group) : '',
            color: isSet(object.color) ? globalThis.String(object.color) : '',
            icon: isSet(object.icon)
                ? exports.TransactionCategoryIcon.fromJSON(object.icon)
                : exports.TransactionCategoryIcon.fromPartial({}),
        };
        if (isSet(object.category)) {
            message.category = globalThis.String(object.category);
        }
        if (isSet(object.subCategory)) {
            message.subCategory = globalThis.String(object.subCategory);
        }
        if (isSet(object.hideLocation)) {
            message.hideLocation = globalThis.Boolean(object.hideLocation);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.group !== '') {
            obj.group = message.group;
        }
        if (message.category !== undefined && message.category !== '') {
            obj.category = message.category;
        }
        if (message.subCategory !== undefined && message.subCategory !== '') {
            obj.subCategory = message.subCategory;
        }
        if (message.color !== '') {
            obj.color = message.color;
        }
        if (message.icon !== undefined) {
            obj.icon = exports.TransactionCategoryIcon.toJSON(message.icon);
        }
        if (message.hideLocation !== undefined && message.hideLocation !== false) {
            obj.hideLocation = message.hideLocation;
        }
        return obj;
    },
    create(base) {
        return exports.TransactionCategory.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransactionCategory();
        message.group = object.group ?? '';
        message.category = object.category ?? '';
        message.subCategory = object.subCategory ?? '';
        message.color = object.color ?? '';
        message.icon = (object.icon !== undefined && object.icon !== null)
            ? exports.TransactionCategoryIcon.fromPartial(object.icon)
            : exports.TransactionCategoryIcon.fromPartial({});
        message.hideLocation = object.hideLocation ?? false;
        return message;
    },
};
function createBaseTransactionCategoryIcon() {
    return { fontAwesome: '', url: '' };
}
exports.TransactionCategoryIcon = {
    fromJSON(object) {
        const message = {
            fontAwesome: isSet(object.fontAwesome) ? globalThis.String(object.fontAwesome) : '',
        };
        if (isSet(object.url)) {
            message.url = globalThis.String(object.url);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fontAwesome !== '') {
            obj.fontAwesome = message.fontAwesome;
        }
        if (message.url !== undefined && message.url !== '') {
            obj.url = message.url;
        }
        return obj;
    },
    create(base) {
        return exports.TransactionCategoryIcon.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransactionCategoryIcon();
        message.fontAwesome = object.fontAwesome ?? '';
        message.url = object.url ?? '';
        return message;
    },
};
function transactionTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_TRANSACTION_TYPE':
            return TransactionType.INVALID_TRANSACTION_TYPE;
        case 97:
        case 'ATM_FEE':
            return TransactionType.ATM_FEE;
        case 98:
        case 'ATM_FEE_REVERSAL':
            return TransactionType.ATM_FEE_REVERSAL;
        case 34:
        case 'ATM_FEE_REIMBURSEMENT':
            return TransactionType.ATM_FEE_REIMBURSEMENT;
        case 35:
        case 'ATM_FEE_REIMBURSEMENT_REVERSAL':
            return TransactionType.ATM_FEE_REIMBURSEMENT_REVERSAL;
        case 1:
        case 'CARD_AUTH':
            return TransactionType.CARD_AUTH;
        case 9:
        case 'CARD_RE_AUTH':
            return TransactionType.CARD_RE_AUTH;
        case 2:
        case 'CARD_REVERSAL':
            return TransactionType.CARD_REVERSAL;
        case 3:
        case 'CARD_CAPTURE':
            return TransactionType.CARD_CAPTURE;
        case 4:
        case 'CARD_REFUND':
            return TransactionType.CARD_REFUND;
        case 6:
        case 'CARD_SETTLEMENT':
            return TransactionType.CARD_SETTLEMENT;
        case 7:
        case 'CARD_DISPUTE':
            return TransactionType.CARD_DISPUTE;
        case 8:
        case 'CARD_DISPUTE_REVERSAL':
            return TransactionType.CARD_DISPUTE_REVERSAL;
        case 17:
        case 'CARD_DISPUTE_INITIATION':
            return TransactionType.CARD_DISPUTE_INITIATION;
        case 18:
        case 'CARD_DISPUTE_RESOLUTION':
            return TransactionType.CARD_DISPUTE_RESOLUTION;
        case 10:
        case 'CARD_DEBIT':
            return TransactionType.CARD_DEBIT;
        case 11:
        case 'CARD_CREDIT':
            return TransactionType.CARD_CREDIT;
        case 71:
        case 'CARD_PURCHASE_TRANSFER':
            return TransactionType.CARD_PURCHASE_TRANSFER;
        case 72:
        case 'CARD_PURCHASE_ROLLOVER':
            return TransactionType.CARD_PURCHASE_ROLLOVER;
        case 73:
        case 'CARD_PURCHASE_TRANSFER_ADJUSTMENT':
            return TransactionType.CARD_PURCHASE_TRANSFER_ADJUSTMENT;
        case 76:
        case 'CREDIT_BILLING_PRINCIPAL':
            return TransactionType.CREDIT_BILLING_PRINCIPAL;
        case 77:
        case 'CREDIT_BILLING_INTEREST':
            return TransactionType.CREDIT_BILLING_INTEREST;
        case 86:
        case 'CREDIT_BILLING_FEE':
            return TransactionType.CREDIT_BILLING_FEE;
        case 81:
        case 'CREDIT_PAYMENT':
            return TransactionType.CREDIT_PAYMENT;
        case 87:
        case 'CREDIT_BALANCE_CATEGORIZATION':
            return TransactionType.CREDIT_BALANCE_CATEGORIZATION;
        case 91:
        case 'CREDIT_REBALANCE':
            return TransactionType.CREDIT_REBALANCE;
        case 5:
        case 'TRANSFER':
            return TransactionType.TRANSFER;
        case 27:
        case 'TRANSFER_REVERSAL':
            return TransactionType.TRANSFER_REVERSAL;
        case 31:
        case 'TRANSFER_HOLD':
            return TransactionType.TRANSFER_HOLD;
        case 32:
        case 'TRANSFER_HOLD_REVERSAL':
            return TransactionType.TRANSFER_HOLD_REVERSAL;
        case 70:
        case 'USER_TO_STEP_TRANSFER':
            return TransactionType.USER_TO_STEP_TRANSFER;
        case 12:
        case 'METADATA_UPDATE':
            return TransactionType.METADATA_UPDATE;
        case 58:
        case 'PENDING_TRANSFER_DESTINATION':
            return TransactionType.PENDING_TRANSFER_DESTINATION;
        case 13:
        case 'FUNDING':
            return TransactionType.FUNDING;
        case 14:
        case 'FUNDING_DISPUTE':
            return TransactionType.FUNDING_DISPUTE;
        case 15:
        case 'FUNDING_DISPUTE_REVERSAL':
            return TransactionType.FUNDING_DISPUTE_REVERSAL;
        case 16:
        case 'FUNDING_REVERSAL':
            return TransactionType.FUNDING_REVERSAL;
        case 33:
        case 'UNAUTHENTICATED_CARD_FUNDING':
            return TransactionType.UNAUTHENTICATED_CARD_FUNDING;
        case 52:
        case 'FUNDING_FEE':
            return TransactionType.FUNDING_FEE;
        case 53:
        case 'FUNDING_FEE_REVERSAL':
            return TransactionType.FUNDING_FEE_REVERSAL;
        case 19:
        case 'ACH_IN_DEBIT':
            return TransactionType.ACH_IN_DEBIT;
        case 20:
        case 'ACH_IN_CREDIT':
            return TransactionType.ACH_IN_CREDIT;
        case 21:
        case 'ACH_IN_DEBIT_RETURN':
            return TransactionType.ACH_IN_DEBIT_RETURN;
        case 22:
        case 'ACH_IN_CREDIT_RETURN':
            return TransactionType.ACH_IN_CREDIT_RETURN;
        case 23:
        case 'ACH_OUT_DEBIT':
            return TransactionType.ACH_OUT_DEBIT;
        case 24:
        case 'ACH_OUT_CREDIT':
            return TransactionType.ACH_OUT_CREDIT;
        case 25:
        case 'ACH_OUT_DEBIT_RETURN':
            return TransactionType.ACH_OUT_DEBIT_RETURN;
        case 26:
        case 'ACH_OUT_CREDIT_RETURN':
            return TransactionType.ACH_OUT_CREDIT_RETURN;
        case 28:
        case 'CASH_DEPOSIT':
            return TransactionType.CASH_DEPOSIT;
        case 29:
        case 'CASH_DEPOSIT_REVERSAL':
            return TransactionType.CASH_DEPOSIT_REVERSAL;
        case 30:
        case 'CASH_DEPOSIT_SETTLEMENT':
            return TransactionType.CASH_DEPOSIT_SETTLEMENT;
        case 54:
        case 'CASH_DEPOSIT_REV_SHARE_PAYMENT':
            return TransactionType.CASH_DEPOSIT_REV_SHARE_PAYMENT;
        case 36:
        case 'LOAN_FUNDING':
            return TransactionType.LOAN_FUNDING;
        case 37:
        case 'LOAN_PRINCIPAL':
            return TransactionType.LOAN_PRINCIPAL;
        case 38:
        case 'LOAN_FEE':
            return TransactionType.LOAN_FEE;
        case 39:
        case 'LOAN_PRINCIPAL_PAYMENT':
            return TransactionType.LOAN_PRINCIPAL_PAYMENT;
        case 40:
        case 'LOAN_FEE_PAYMENT':
            return TransactionType.LOAN_FEE_PAYMENT;
        case 89:
        case 'CASH_ADVANCE_FUNDING':
            return TransactionType.CASH_ADVANCE_FUNDING;
        case 90:
        case 'CASH_ADVANCE_PRINCIPAL':
            return TransactionType.CASH_ADVANCE_PRINCIPAL;
        case 41:
        case 'OPTIONAL_FEE_PAYMENT':
            return TransactionType.OPTIONAL_FEE_PAYMENT;
        case 42:
        case 'REWARD_PAYOUT':
            return TransactionType.REWARD_PAYOUT;
        case 43:
        case 'REWARD_ADJUSTMENT':
            return TransactionType.REWARD_ADJUSTMENT;
        case 45:
        case 'CRYPTO_BUY':
            return TransactionType.CRYPTO_BUY;
        case 46:
        case 'CRYPTO_SELL':
            return TransactionType.CRYPTO_SELL;
        case 57:
        case 'CRYPTO_SELL_REVERSAL':
            return TransactionType.CRYPTO_SELL_REVERSAL;
        case 51:
        case 'CRYPTO_TRANSFER':
            return TransactionType.CRYPTO_TRANSFER;
        case 100:
        case 'CRYPTO_TRANSFER_REVERSAL':
            return TransactionType.CRYPTO_TRANSFER_REVERSAL;
        case 47:
        case 'CRYPTO_BUY_TRANSFER':
            return TransactionType.CRYPTO_BUY_TRANSFER;
        case 49:
        case 'CRYPTO_BUY_TRANSFER_HOLD':
            return TransactionType.CRYPTO_BUY_TRANSFER_HOLD;
        case 50:
        case 'CRYPTO_BUY_TRANSFER_HOLD_REVERSAL':
            return TransactionType.CRYPTO_BUY_TRANSFER_HOLD_REVERSAL;
        case 48:
        case 'CRYPTO_SELL_TRANSFER':
            return TransactionType.CRYPTO_SELL_TRANSFER;
        case 55:
        case 'CHECK_DEPOSIT':
            return TransactionType.CHECK_DEPOSIT;
        case 56:
        case 'CHECK_DEPOSIT_RETURN':
            return TransactionType.CHECK_DEPOSIT_RETURN;
        case 59:
        case 'CHECK_DEPOSIT_SETTLEMENT':
            return TransactionType.CHECK_DEPOSIT_SETTLEMENT;
        case 60:
        case 'CARD_PAYOUT':
            return TransactionType.CARD_PAYOUT;
        case 61:
        case 'CARD_PAYOUT_FEE':
            return TransactionType.CARD_PAYOUT_FEE;
        case 68:
        case 'CARD_PAYOUT_FEE_REVERSAL':
            return TransactionType.CARD_PAYOUT_FEE_REVERSAL;
        case 69:
        case 'CARD_PAYOUT_REVERSAL':
            return TransactionType.CARD_PAYOUT_REVERSAL;
        case 93:
        case 'GIFT_CARD_ORDER':
            return TransactionType.GIFT_CARD_ORDER;
        case 94:
        case 'GIFT_CARD_ORDER_REVERSAL':
            return TransactionType.GIFT_CARD_ORDER_REVERSAL;
        case 96:
        case 'GIFT_CARD_SETTLEMENT':
            return TransactionType.GIFT_CARD_SETTLEMENT;
        case 62:
        case 'STOCK_BUY_TRANSFER':
            return TransactionType.STOCK_BUY_TRANSFER;
        case 63:
        case 'STOCK_BUY_TRANSFER_HOLD':
            return TransactionType.STOCK_BUY_TRANSFER_HOLD;
        case 64:
        case 'STOCK_BUY_TRANSFER_HOLD_REVERSAL':
            return TransactionType.STOCK_BUY_TRANSFER_HOLD_REVERSAL;
        case 65:
        case 'STOCK_SELL_TRANSFER':
            return TransactionType.STOCK_SELL_TRANSFER;
        case 66:
        case 'STOCK_CORPORATE_ACTION_DEBIT':
            return TransactionType.STOCK_CORPORATE_ACTION_DEBIT;
        case 67:
        case 'STOCK_CORPORATE_ACTION_CREDIT':
            return TransactionType.STOCK_CORPORATE_ACTION_CREDIT;
        case 74:
        case 'STOCK_BUY_TRANSFER_ADJUSTMENT':
            return TransactionType.STOCK_BUY_TRANSFER_ADJUSTMENT;
        case 75:
        case 'STOCK_SELL_TRANSFER_ADJUSTMENT':
            return TransactionType.STOCK_SELL_TRANSFER_ADJUSTMENT;
        case 78:
        case 'STOCK_INTEREST_ADJUSTMENT_CREDIT':
            return TransactionType.STOCK_INTEREST_ADJUSTMENT_CREDIT;
        case 79:
        case 'STOCK_INTEREST_ADJUSTMENT_DEBIT':
            return TransactionType.STOCK_INTEREST_ADJUSTMENT_DEBIT;
        case 95:
        case 'STOCK_CUSTOMER_ACCOUNT_TRANSFER':
            return TransactionType.STOCK_CUSTOMER_ACCOUNT_TRANSFER;
        case 80:
        case 'SAVINGS_INTEREST':
            return TransactionType.SAVINGS_INTEREST;
        case 101:
        case 'PHYSICAL_CARD_PAYMENT':
            return TransactionType.PHYSICAL_CARD_PAYMENT;
        case 102:
        case 'PHYSICAL_CARD_TAX':
            return TransactionType.PHYSICAL_CARD_TAX;
        case 83:
        case 'POINTS_REWARD':
            return TransactionType.POINTS_REWARD;
        case 84:
        case 'POINTS_REDEEM':
            return TransactionType.POINTS_REDEEM;
        case 85:
        case 'POINTS_REWARD_ADJUSTMENT':
            return TransactionType.POINTS_REWARD_ADJUSTMENT;
        case 88:
        case 'SUBSCRIPTION_FEE':
            return TransactionType.SUBSCRIPTION_FEE;
        case 99:
        case 'SUBSCRIPTION_FEE_REFUND':
            return TransactionType.SUBSCRIPTION_FEE_REFUND;
        case 92:
        case 'SAVINGS_MATCH':
            return TransactionType.SAVINGS_MATCH;
        case 82:
        case 'DEPRECATED_CREDIT_PAYMENT_INTEREST':
            return TransactionType.DEPRECATED_CREDIT_PAYMENT_INTEREST;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransactionType.UNRECOGNIZED;
    }
}
exports.transactionTypeFromJSON = transactionTypeFromJSON;
function transactionTypeToJSON(object) {
    switch (object) {
        case TransactionType.INVALID_TRANSACTION_TYPE:
            return 'INVALID_TRANSACTION_TYPE';
        case TransactionType.ATM_FEE:
            return 'ATM_FEE';
        case TransactionType.ATM_FEE_REVERSAL:
            return 'ATM_FEE_REVERSAL';
        case TransactionType.ATM_FEE_REIMBURSEMENT:
            return 'ATM_FEE_REIMBURSEMENT';
        case TransactionType.ATM_FEE_REIMBURSEMENT_REVERSAL:
            return 'ATM_FEE_REIMBURSEMENT_REVERSAL';
        case TransactionType.CARD_AUTH:
            return 'CARD_AUTH';
        case TransactionType.CARD_RE_AUTH:
            return 'CARD_RE_AUTH';
        case TransactionType.CARD_REVERSAL:
            return 'CARD_REVERSAL';
        case TransactionType.CARD_CAPTURE:
            return 'CARD_CAPTURE';
        case TransactionType.CARD_REFUND:
            return 'CARD_REFUND';
        case TransactionType.CARD_SETTLEMENT:
            return 'CARD_SETTLEMENT';
        case TransactionType.CARD_DISPUTE:
            return 'CARD_DISPUTE';
        case TransactionType.CARD_DISPUTE_REVERSAL:
            return 'CARD_DISPUTE_REVERSAL';
        case TransactionType.CARD_DISPUTE_INITIATION:
            return 'CARD_DISPUTE_INITIATION';
        case TransactionType.CARD_DISPUTE_RESOLUTION:
            return 'CARD_DISPUTE_RESOLUTION';
        case TransactionType.CARD_DEBIT:
            return 'CARD_DEBIT';
        case TransactionType.CARD_CREDIT:
            return 'CARD_CREDIT';
        case TransactionType.CARD_PURCHASE_TRANSFER:
            return 'CARD_PURCHASE_TRANSFER';
        case TransactionType.CARD_PURCHASE_ROLLOVER:
            return 'CARD_PURCHASE_ROLLOVER';
        case TransactionType.CARD_PURCHASE_TRANSFER_ADJUSTMENT:
            return 'CARD_PURCHASE_TRANSFER_ADJUSTMENT';
        case TransactionType.CREDIT_BILLING_PRINCIPAL:
            return 'CREDIT_BILLING_PRINCIPAL';
        case TransactionType.CREDIT_BILLING_INTEREST:
            return 'CREDIT_BILLING_INTEREST';
        case TransactionType.CREDIT_BILLING_FEE:
            return 'CREDIT_BILLING_FEE';
        case TransactionType.CREDIT_PAYMENT:
            return 'CREDIT_PAYMENT';
        case TransactionType.CREDIT_BALANCE_CATEGORIZATION:
            return 'CREDIT_BALANCE_CATEGORIZATION';
        case TransactionType.CREDIT_REBALANCE:
            return 'CREDIT_REBALANCE';
        case TransactionType.TRANSFER:
            return 'TRANSFER';
        case TransactionType.TRANSFER_REVERSAL:
            return 'TRANSFER_REVERSAL';
        case TransactionType.TRANSFER_HOLD:
            return 'TRANSFER_HOLD';
        case TransactionType.TRANSFER_HOLD_REVERSAL:
            return 'TRANSFER_HOLD_REVERSAL';
        case TransactionType.USER_TO_STEP_TRANSFER:
            return 'USER_TO_STEP_TRANSFER';
        case TransactionType.METADATA_UPDATE:
            return 'METADATA_UPDATE';
        case TransactionType.PENDING_TRANSFER_DESTINATION:
            return 'PENDING_TRANSFER_DESTINATION';
        case TransactionType.FUNDING:
            return 'FUNDING';
        case TransactionType.FUNDING_DISPUTE:
            return 'FUNDING_DISPUTE';
        case TransactionType.FUNDING_DISPUTE_REVERSAL:
            return 'FUNDING_DISPUTE_REVERSAL';
        case TransactionType.FUNDING_REVERSAL:
            return 'FUNDING_REVERSAL';
        case TransactionType.UNAUTHENTICATED_CARD_FUNDING:
            return 'UNAUTHENTICATED_CARD_FUNDING';
        case TransactionType.FUNDING_FEE:
            return 'FUNDING_FEE';
        case TransactionType.FUNDING_FEE_REVERSAL:
            return 'FUNDING_FEE_REVERSAL';
        case TransactionType.ACH_IN_DEBIT:
            return 'ACH_IN_DEBIT';
        case TransactionType.ACH_IN_CREDIT:
            return 'ACH_IN_CREDIT';
        case TransactionType.ACH_IN_DEBIT_RETURN:
            return 'ACH_IN_DEBIT_RETURN';
        case TransactionType.ACH_IN_CREDIT_RETURN:
            return 'ACH_IN_CREDIT_RETURN';
        case TransactionType.ACH_OUT_DEBIT:
            return 'ACH_OUT_DEBIT';
        case TransactionType.ACH_OUT_CREDIT:
            return 'ACH_OUT_CREDIT';
        case TransactionType.ACH_OUT_DEBIT_RETURN:
            return 'ACH_OUT_DEBIT_RETURN';
        case TransactionType.ACH_OUT_CREDIT_RETURN:
            return 'ACH_OUT_CREDIT_RETURN';
        case TransactionType.CASH_DEPOSIT:
            return 'CASH_DEPOSIT';
        case TransactionType.CASH_DEPOSIT_REVERSAL:
            return 'CASH_DEPOSIT_REVERSAL';
        case TransactionType.CASH_DEPOSIT_SETTLEMENT:
            return 'CASH_DEPOSIT_SETTLEMENT';
        case TransactionType.CASH_DEPOSIT_REV_SHARE_PAYMENT:
            return 'CASH_DEPOSIT_REV_SHARE_PAYMENT';
        case TransactionType.LOAN_FUNDING:
            return 'LOAN_FUNDING';
        case TransactionType.LOAN_PRINCIPAL:
            return 'LOAN_PRINCIPAL';
        case TransactionType.LOAN_FEE:
            return 'LOAN_FEE';
        case TransactionType.LOAN_PRINCIPAL_PAYMENT:
            return 'LOAN_PRINCIPAL_PAYMENT';
        case TransactionType.LOAN_FEE_PAYMENT:
            return 'LOAN_FEE_PAYMENT';
        case TransactionType.CASH_ADVANCE_FUNDING:
            return 'CASH_ADVANCE_FUNDING';
        case TransactionType.CASH_ADVANCE_PRINCIPAL:
            return 'CASH_ADVANCE_PRINCIPAL';
        case TransactionType.OPTIONAL_FEE_PAYMENT:
            return 'OPTIONAL_FEE_PAYMENT';
        case TransactionType.REWARD_PAYOUT:
            return 'REWARD_PAYOUT';
        case TransactionType.REWARD_ADJUSTMENT:
            return 'REWARD_ADJUSTMENT';
        case TransactionType.CRYPTO_BUY:
            return 'CRYPTO_BUY';
        case TransactionType.CRYPTO_SELL:
            return 'CRYPTO_SELL';
        case TransactionType.CRYPTO_SELL_REVERSAL:
            return 'CRYPTO_SELL_REVERSAL';
        case TransactionType.CRYPTO_TRANSFER:
            return 'CRYPTO_TRANSFER';
        case TransactionType.CRYPTO_TRANSFER_REVERSAL:
            return 'CRYPTO_TRANSFER_REVERSAL';
        case TransactionType.CRYPTO_BUY_TRANSFER:
            return 'CRYPTO_BUY_TRANSFER';
        case TransactionType.CRYPTO_BUY_TRANSFER_HOLD:
            return 'CRYPTO_BUY_TRANSFER_HOLD';
        case TransactionType.CRYPTO_BUY_TRANSFER_HOLD_REVERSAL:
            return 'CRYPTO_BUY_TRANSFER_HOLD_REVERSAL';
        case TransactionType.CRYPTO_SELL_TRANSFER:
            return 'CRYPTO_SELL_TRANSFER';
        case TransactionType.CHECK_DEPOSIT:
            return 'CHECK_DEPOSIT';
        case TransactionType.CHECK_DEPOSIT_RETURN:
            return 'CHECK_DEPOSIT_RETURN';
        case TransactionType.CHECK_DEPOSIT_SETTLEMENT:
            return 'CHECK_DEPOSIT_SETTLEMENT';
        case TransactionType.CARD_PAYOUT:
            return 'CARD_PAYOUT';
        case TransactionType.CARD_PAYOUT_FEE:
            return 'CARD_PAYOUT_FEE';
        case TransactionType.CARD_PAYOUT_FEE_REVERSAL:
            return 'CARD_PAYOUT_FEE_REVERSAL';
        case TransactionType.CARD_PAYOUT_REVERSAL:
            return 'CARD_PAYOUT_REVERSAL';
        case TransactionType.GIFT_CARD_ORDER:
            return 'GIFT_CARD_ORDER';
        case TransactionType.GIFT_CARD_ORDER_REVERSAL:
            return 'GIFT_CARD_ORDER_REVERSAL';
        case TransactionType.GIFT_CARD_SETTLEMENT:
            return 'GIFT_CARD_SETTLEMENT';
        case TransactionType.STOCK_BUY_TRANSFER:
            return 'STOCK_BUY_TRANSFER';
        case TransactionType.STOCK_BUY_TRANSFER_HOLD:
            return 'STOCK_BUY_TRANSFER_HOLD';
        case TransactionType.STOCK_BUY_TRANSFER_HOLD_REVERSAL:
            return 'STOCK_BUY_TRANSFER_HOLD_REVERSAL';
        case TransactionType.STOCK_SELL_TRANSFER:
            return 'STOCK_SELL_TRANSFER';
        case TransactionType.STOCK_CORPORATE_ACTION_DEBIT:
            return 'STOCK_CORPORATE_ACTION_DEBIT';
        case TransactionType.STOCK_CORPORATE_ACTION_CREDIT:
            return 'STOCK_CORPORATE_ACTION_CREDIT';
        case TransactionType.STOCK_BUY_TRANSFER_ADJUSTMENT:
            return 'STOCK_BUY_TRANSFER_ADJUSTMENT';
        case TransactionType.STOCK_SELL_TRANSFER_ADJUSTMENT:
            return 'STOCK_SELL_TRANSFER_ADJUSTMENT';
        case TransactionType.STOCK_INTEREST_ADJUSTMENT_CREDIT:
            return 'STOCK_INTEREST_ADJUSTMENT_CREDIT';
        case TransactionType.STOCK_INTEREST_ADJUSTMENT_DEBIT:
            return 'STOCK_INTEREST_ADJUSTMENT_DEBIT';
        case TransactionType.STOCK_CUSTOMER_ACCOUNT_TRANSFER:
            return 'STOCK_CUSTOMER_ACCOUNT_TRANSFER';
        case TransactionType.SAVINGS_INTEREST:
            return 'SAVINGS_INTEREST';
        case TransactionType.PHYSICAL_CARD_PAYMENT:
            return 'PHYSICAL_CARD_PAYMENT';
        case TransactionType.PHYSICAL_CARD_TAX:
            return 'PHYSICAL_CARD_TAX';
        case TransactionType.POINTS_REWARD:
            return 'POINTS_REWARD';
        case TransactionType.POINTS_REDEEM:
            return 'POINTS_REDEEM';
        case TransactionType.POINTS_REWARD_ADJUSTMENT:
            return 'POINTS_REWARD_ADJUSTMENT';
        case TransactionType.SUBSCRIPTION_FEE:
            return 'SUBSCRIPTION_FEE';
        case TransactionType.SUBSCRIPTION_FEE_REFUND:
            return 'SUBSCRIPTION_FEE_REFUND';
        case TransactionType.SAVINGS_MATCH:
            return 'SAVINGS_MATCH';
        case TransactionType.DEPRECATED_CREDIT_PAYMENT_INTEREST:
            return 'DEPRECATED_CREDIT_PAYMENT_INTEREST';
        case TransactionType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transactionTypeToJSON = transactionTypeToJSON;
function controlCategoryFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CONTROL_CATEGORY':
            return ControlCategory.INVALID_CONTROL_CATEGORY;
        case 1:
        case 'INTERNAL_TRANSACTION':
            return ControlCategory.INTERNAL_TRANSACTION;
        case 10:
        case 'CARD_PHYSICAL':
            return ControlCategory.CARD_PHYSICAL;
        case 11:
        case 'CARD_WALLET':
            return ControlCategory.CARD_WALLET;
        case 15:
        case 'CARD_VIRTUAL':
            return ControlCategory.CARD_VIRTUAL;
        case 2:
        case 'CARD_GENERIC':
            return ControlCategory.CARD_GENERIC;
        case 3:
        case 'CARD_ATM':
            return ControlCategory.CARD_ATM;
        case 4:
        case 'CARD_CASH_BACK':
            return ControlCategory.CARD_CASH_BACK;
        case 5:
        case 'CARD_OTC_WITHDRAWAL':
            return ControlCategory.CARD_OTC_WITHDRAWAL;
        case 6:
        case 'P2P_TRANSACTION':
            return ControlCategory.P2P_TRANSACTION;
        case 7:
        case 'CARD_FUNDING_TRANSACTION':
            return ControlCategory.CARD_FUNDING_TRANSACTION;
        case 16:
        case 'UNAUTHENTICATED_CARD_FUNDING_TRANSACTION':
            return ControlCategory.UNAUTHENTICATED_CARD_FUNDING_TRANSACTION;
        case 8:
        case 'ACH_IN_FUNDING':
            return ControlCategory.ACH_IN_FUNDING;
        case 12:
        case 'ACH_IN_WITHDRAWAL':
            return ControlCategory.ACH_IN_WITHDRAWAL;
        case 9:
        case 'ACH_OUT_FUNDING':
            return ControlCategory.ACH_OUT_FUNDING;
        case 13:
        case 'ACH_OUT_WITHDRAWAL':
            return ControlCategory.ACH_OUT_WITHDRAWAL;
        case 14:
        case 'CASH_DEPOSIT_TRANSACTION':
            return ControlCategory.CASH_DEPOSIT_TRANSACTION;
        case 17:
        case 'CRYPTO_BUY_TRANSFER_TRANSACTION':
            return ControlCategory.CRYPTO_BUY_TRANSFER_TRANSACTION;
        case 18:
        case 'CHECK_DEPOSIT_TRANSACTION':
            return ControlCategory.CHECK_DEPOSIT_TRANSACTION;
        case 19:
        case 'CARD_PAYOUT_TRANSACTION':
            return ControlCategory.CARD_PAYOUT_TRANSACTION;
        case 20:
        case 'USER_TO_STEP_TRANSACTION':
            return ControlCategory.USER_TO_STEP_TRANSACTION;
        case 21:
        case 'STOCK_BUY_TRANSFER_TRANSACTION':
            return ControlCategory.STOCK_BUY_TRANSFER_TRANSACTION;
        case 22:
        case 'POINTS_TRANSACTION':
            return ControlCategory.POINTS_TRANSACTION;
        case 23:
        case 'INTRA_FAMILY_TRANSACTION':
            return ControlCategory.INTRA_FAMILY_TRANSACTION;
        case 24:
        case 'GIFT_CARD_ORDER_TRANSACTION':
            return ControlCategory.GIFT_CARD_ORDER_TRANSACTION;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ControlCategory.UNRECOGNIZED;
    }
}
exports.controlCategoryFromJSON = controlCategoryFromJSON;
function controlCategoryToJSON(object) {
    switch (object) {
        case ControlCategory.INVALID_CONTROL_CATEGORY:
            return 'INVALID_CONTROL_CATEGORY';
        case ControlCategory.INTERNAL_TRANSACTION:
            return 'INTERNAL_TRANSACTION';
        case ControlCategory.CARD_PHYSICAL:
            return 'CARD_PHYSICAL';
        case ControlCategory.CARD_WALLET:
            return 'CARD_WALLET';
        case ControlCategory.CARD_VIRTUAL:
            return 'CARD_VIRTUAL';
        case ControlCategory.CARD_GENERIC:
            return 'CARD_GENERIC';
        case ControlCategory.CARD_ATM:
            return 'CARD_ATM';
        case ControlCategory.CARD_CASH_BACK:
            return 'CARD_CASH_BACK';
        case ControlCategory.CARD_OTC_WITHDRAWAL:
            return 'CARD_OTC_WITHDRAWAL';
        case ControlCategory.P2P_TRANSACTION:
            return 'P2P_TRANSACTION';
        case ControlCategory.CARD_FUNDING_TRANSACTION:
            return 'CARD_FUNDING_TRANSACTION';
        case ControlCategory.UNAUTHENTICATED_CARD_FUNDING_TRANSACTION:
            return 'UNAUTHENTICATED_CARD_FUNDING_TRANSACTION';
        case ControlCategory.ACH_IN_FUNDING:
            return 'ACH_IN_FUNDING';
        case ControlCategory.ACH_IN_WITHDRAWAL:
            return 'ACH_IN_WITHDRAWAL';
        case ControlCategory.ACH_OUT_FUNDING:
            return 'ACH_OUT_FUNDING';
        case ControlCategory.ACH_OUT_WITHDRAWAL:
            return 'ACH_OUT_WITHDRAWAL';
        case ControlCategory.CASH_DEPOSIT_TRANSACTION:
            return 'CASH_DEPOSIT_TRANSACTION';
        case ControlCategory.CRYPTO_BUY_TRANSFER_TRANSACTION:
            return 'CRYPTO_BUY_TRANSFER_TRANSACTION';
        case ControlCategory.CHECK_DEPOSIT_TRANSACTION:
            return 'CHECK_DEPOSIT_TRANSACTION';
        case ControlCategory.CARD_PAYOUT_TRANSACTION:
            return 'CARD_PAYOUT_TRANSACTION';
        case ControlCategory.USER_TO_STEP_TRANSACTION:
            return 'USER_TO_STEP_TRANSACTION';
        case ControlCategory.STOCK_BUY_TRANSFER_TRANSACTION:
            return 'STOCK_BUY_TRANSFER_TRANSACTION';
        case ControlCategory.POINTS_TRANSACTION:
            return 'POINTS_TRANSACTION';
        case ControlCategory.INTRA_FAMILY_TRANSACTION:
            return 'INTRA_FAMILY_TRANSACTION';
        case ControlCategory.GIFT_CARD_ORDER_TRANSACTION:
            return 'GIFT_CARD_ORDER_TRANSACTION';
        case ControlCategory.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.controlCategoryToJSON = controlCategoryToJSON;
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=transaction.js.map